import React, { useState } from "react";
import { useNavigate  } from "react-router-dom";
import { db } from "../../firebase";
import { ref, get } from "firebase/database";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";



export default function Login() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [popup, setPopup] = useState({ show: false, message: "" });
  const [loginType, setLoginType] = useState("Customer"); // 👈 toggle state
  const navigate = useNavigate();

  const showPopup = (msg) => {
    setPopup({ show: true, message: msg });
    setTimeout(() => setPopup({ show: false, message: "" }), 2500);
  };

  const handleLogin = async () => {
    setError("");

    try {
      if (loginType === "Customer") {
        const usersRef = ref(db, "users/");
        const snapshot = await get(usersRef);

        if (!snapshot.exists()) {
          setError("No users found ❌");
          return;
        }

        const data = snapshot.val();
        const usersArray = Object.keys(data).map((key) => ({
          firebaseKey: key,
          ...data[key],
        }));

        const foundUser = usersArray.find(
          (u) =>
            u.userId?.trim().toLowerCase() ===
              form.email.trim().toLowerCase() &&
            u.password?.trim() === form.password.trim()
        );

        if (!foundUser) {
          setError("Invalid User ID or Password ❌");
          return;
        }

        localStorage.setItem("loggedInUser", JSON.stringify(foundUser));
        window.dispatchEvent(new Event("user-login-change"));
        showPopup(`Welcome ${foundUser.name}! 👋`);
        setTimeout(() => navigate("/profile"), 2500);
      } else if (loginType === "Admin") {
        const adminRef = ref(db, "admins/");
        const snapshot = await get(adminRef);

        if (!snapshot.exists()) {
          setError("No admin found ❌");
          return;
        }

        const data = snapshot.val();
        const adminArray = Object.keys(data).map((key) => ({
          firebaseKey: key,
          ...data[key],
        }));

        const foundAdmin = adminArray.find(
          (a) =>
            a.adminId?.trim().toLowerCase() ===
              form.email.trim().toLowerCase() &&
            a.password?.trim() === form.password.trim()
        );

        if (!foundAdmin) {
          setError("Invalid Admin ID or Password ❌");
          return;
        }

        localStorage.setItem("loggedInAdmin", JSON.stringify(foundAdmin));
        window.dispatchEvent(new Event("user-login-change"));
        showPopup(`Welcome back Admin, ${foundAdmin.name} 👑`);
        setTimeout(() => navigate("/admin"), 2500);
      }
    } catch (error) {
      console.error("Login Error:", error);
      setError("Something went wrong ❌");
    }
  };

  return (
    <>
      <style>{`
        .auth-container {
          min-height: 100vh;
          display: flex;
          justify-content: center;
          align-items: center;
          background: linear-gradient(120deg, #03b8b3, #04d4cd);
          padding: 20px;
        }
        .auth-box {
          background: rgba(255,255,255,0.85);
          backdrop-filter: blur(12px);
          padding: 35px 30px;
          border-radius: 16px;
          width: 100%;
          max-width: 400px;
          box-shadow: 0 8px 20px rgba(0,0,0,0.12);
          animation: pop .3s ease;
          position: relative;
        }
        @keyframes pop {
          from { opacity:0; transform:scale(.9); }
          to { opacity:1; transform:scale(1); }
        }
        .auth-title {
          text-align: center;
          font-size: 28px;
          font-weight: 800;
          color: #022c32;
          margin-bottom: 20px;
        }
        .auth-input {
          width: 93%;
          padding: 12px;
          border-radius: 10px;
          border: 1px solid #bcd6db;
          margin-bottom: 14px;
          font-size: 15px;
          outline: none;
          transition: .2s;
        }
        .auth-input:focus {
          border-color: #03b8b3;
          box-shadow: 0 0 6px rgba(3,184,179,0.4);
        }
        .auth-btn {
          width: 100%;
          padding: 12px;
          border: none;
          border-radius: 10px;
          background: linear-gradient(120deg, #03b8b3, #04d4cd);
          color: #fff;
          font-size: 16px;
          font-weight: 700;
          cursor: pointer;
          transition: .2s;
          margin-top: 5px;
        }
        .auth-btn:hover {
          transform: scale(1.03);
        }
        .error {
          color: red;
          margin-bottom: 10px;
          text-align: center;
          font-size: 14px;
        }

        /* Toggle Button Section */
        .toggle-container {
          display: flex;
          justify-content: center;
          gap: 15px;
          margin-top: 18px;
        }
        .toggle-btn {
          padding: 8px 20px;
          border-radius: 20px;
          border: none;
          cursor: pointer;
          font-weight: 600;
          background: #e5f7f6;
          color: #066464;
          transition: 0.3s;
        }
        .toggle-btn.active {
          background: linear-gradient(120deg, #03b8b3, #04d4cd);
          color: #fff;
          box-shadow: 0 3px 8px rgba(0,0,0,0.15);
          transform: scale(1.05);
        }

        /* ✅ Popup animation */
        .popup {
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: #fff;
          border-radius: 18px;
          padding: 25px 30px;
          text-align: center;
          box-shadow: 0 8px 20px rgba(0,0,0,0.3);
          z-index: 1200;
          animation: fadeInOut 2.5s ease;
        }

        .popup h3 {
          color: #03b8b3;
          margin-top: 10px;
          font-weight: 700;
          font-size: 18px;
        }

        @keyframes fadeInOut {
          0% { opacity: 0; transform: translate(-50%, -50%) scale(0.8); }
          15% { opacity: 1; transform: translate(-50%, -50%) scale(1); }
          85% { opacity: 1; }
          100% { opacity: 0; transform: translate(-50%, -50%) scale(0.9); }
        }
      `}</style>

      <div className="auth-container">
        <form className="auth-box" onSubmit={(e) => e.preventDefault()}>
          <div className="auth-title">
            {loginType === "Admin" ? "Admin Login 😎" : "Customer Login 👥"}
          </div>

          {error && <div className="error">{error}</div>}

          <input
            type="text"
            placeholder={
              loginType === "Admin"
                ? "Enter Admin ID"
                : "Enter User ID / Customer ID"
            }
            className="auth-input"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            required
          />

          <input
            type="password"
            placeholder="Enter Password"
            className="auth-input"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            required
          />

          <button type="button" className="auth-btn" onClick={handleLogin}>
            Login as {loginType}
          </button>

          {/* 👇 Toggle Button Group */}
          <div className="toggle-container">
            <button
              type="button"
              className={`toggle-btn ${loginType === "Admin" ? "active" : ""}`}
              onClick={() => setLoginType("Admin")}
            >
              Admin
            </button>
            <button
              type="button"
              className={`toggle-btn ${
                loginType === "Customer" ? "active" : ""
              }`}
              onClick={() => setLoginType("Customer")}
            >
              Customer
            </button>
          </div>
        </form>
      </div>

      {/* ✅ Success Popup */}
      {popup.show && (
        <div className="popup">
          <CheckCircleIcon style={{ color: "#03b8b3", fontSize: "45px" }} />
          <h3>{popup.message}</h3>
        </div>
      )}
    </>
  );
}
